import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useHistory } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";

// Icons
import LocalShippingTwoToneIcon from "@material-ui/icons/LocalShippingTwoTone";
import ShoppingCartTwoToneIcon from "@material-ui/icons/ShoppingCartTwoTone";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ShoppingBasketTwoToneIcon from '@material-ui/icons/ShoppingBasketTwoTone';
import ReceiptIcon from '@material-ui/icons/Receipt';
// Components
import PurchaseOrderApprovalTable from "./PurchaseOrderApprovalTable"; //reused table component
import PurchaseOrderAllocationTable from "./PurchaseOrderAllocationTable"; //reused table component
import PDFPODetailsReference from './PDFPODetailsReference'
//React Router (for getting parameters)
import {  useParams, NavLink } from "react-router-dom";

//number format plugin
import numeral from "numeral";


const useStyles = makeStyles({
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
	infoContainer: {
		marginBottom: "2rem",
		backgroundColor: "rgba(137, 200, 59, 0.09)",
		padding: "1rem",
		border: "1.5px solid #4aba4a",
		borderRadius: "5px",
	},
	infoTitle: {
		fontWeight: "700",
		fontSize: "14px",
	},
	infoContent: {
		fontSize: "14px",
	},
	buttonContainer: {
		textAlign: "right",
		"& button": {
			marginLeft: "0.5rem !important",
		},
	},
	infoTotal: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		marginTop: "1rem",
	},
	infoTotalItem: {
		padding: "0.5rem 1rem",
		border: "1px solid #4aba4a",
		borderRadius: "5px",
		display: "flex",
		alignItems: "center",
		marginBottom: "0.5rem",
		fontWeight: "700",
	},
	infoTotalIcon: {
		marginRight: "0.5rem",
		color: "#4caf50 !important",
	},
	textarea: {
		width: "100%",
		marginTop: "1rem",
	},
	miniTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
});

const PurchaseOrderDetailsReference = () => {
	const { pono, branchidno } = useParams();
	const [supplierInfo, setSupplierInfo] = useState([]);
	const [warehouse, setWarehouse] = useState([]);
	const classes = useStyles();

	const [items, setItems] = useState([]); //data to display in 2nd table
	const [allocation, setAllocation] = useState([]); //data to display in first table

	const [poTotal, setPoTotal] = useState(0);
	const [shipTotal, setShipTotal] = useState(0);
	const [grandTotal, setGrandTotal] = useState(0);
	const [notes, setNotes] = useState('');

	let history = useHistory();

	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	const DownloadPdf = ( { date, deliverTo, mop, contactno, address, items, itemsAllocation, shipping, subTotal, grandTotal, notes	} ) => {
		return (
		<PDFDownloadLink 
			document={
			<PDFPODetailsReference date={date} deliverTo={deliverTo} mop={mop} contactno={contactno} address={address} items={items} itemsAllocation={itemsAllocation} shipping={shipping} subTotal={subTotal} grandTotal={grandTotal} notes={notes} pono={pono} />} 
			fileName={"po-reference-"+pono}>
			{({ loading }) => (loading ? 'loading...' : <Button variant="contained" color="primary">Print PDF</Button> )}
		</PDFDownloadLink>
		)
	}

	const data = async () => {
		// const po_details = await axios.get(process.env.REACT_APP_API_URL+'get_po_details_reference', {
		 await axios.get(process.env.REACT_APP_API_URL+'get_po_details_reference', {
			params:{
				pono: pono,
				jc_u_idno: branchidno
			}
		}).then((res) => {
			
			setItems(res.data.data[2].po_details);
			setSupplierInfo(res.data.data[1].supplier_details);
			setShipTotal(res.data.data[1].supplier_details.shipping);
			setPoTotal(res.data.data[1].supplier_details.subtotal);
			// setGrandTotal(res.data.data[1].supplier_details.grand_total);
			setNotes(res.data.data[1].supplier_details.notes);
			setAllocation(res.data.data[0].allocations);
		}).catch((error) => {
			console.log(error);
		});
	};	



	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<ReceiptIcon />
				</div>
				<NavLink to={"/purchases"}><h2 style={{color:"black"}}>Purchases</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<NavLink to={"/purchases/purchases-order-return-transaction-history"}><h2 style={{color:"black"}}>Purchase Order Return Transaction History</h2></NavLink>
				<ArrowForwardIosIcon style={{paddingLeft: "10px", paddingRight: "10px"}}/>
				<h2>Purchase Order Details Reference</h2>
				{/* <h2>supplier id: {supid} - delivery_date: {delivery_date}</h2> test if param values were passed*/}
			</div>
			<div className="page-container">
				<Card className={classes.card}>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
									Purchase Order Details Reference
								</div>
								<div className={classes.title}>
									Purchase Order Details Reference
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
								{/* <PurchaseEditShipping shipTotal={shipTotal} setShipTotal={setShipTotal}/> */}
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
								<DownloadPdf 
									date		= {supplierInfo.delivery_date || "Date"}
									deliverTo	= {supplierInfo.contactperson || "Delivered To"}
									mop			= {supplierInfo.modeofpayment || "Mode of Payment"}
									contactno	= {supplierInfo.contactno || "Contact Number"}
									address		= {supplierInfo.address || "Address"}
									items	 	= {items}
									itemsAllocation = {allocation}
									shipping	= {numeral(shipTotal).format('0,0.00')}
									subTotal	= {numeral(poTotal).format('0,0.00')}
									grandTotal	= {numeral(shipTotal + poTotal).format('0,0.00')}
									notes		= {notes || ''}
								/>
								{/* <PurchaseAddItem addItem={addItem} supplierItem={supplierItem}/> */}
							</Grid>
					  </Grid>
					</div>
					<CardContent>
						<div className={classes.infoContainer}>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Date: 
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{supplierInfo.delivery_date || "Date"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Delivered To: 
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{supplierInfo.contactperson || "Delivered To"}
								</Grid>
							</Grid>
							{/* <Grid container spacing={3}>
								<Grid item xs={4} className={classes.infoTitle}>
									Branch
								</Grid>
								<Grid
									item
									xs={8}
									className={classes.infoContent}
								>
									{supplier.branchidno || "Branch"}
								</Grid>
							</Grid> */}
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Mode of Payment:
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{supplierInfo.modeofpayment || "Mode of Payment"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Contact Number:
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{supplierInfo.contactno || "Contact Number"}
								</Grid>
							</Grid>
							<Grid container spacing={3}>
								<Grid item xs={2} className={classes.infoTitle}>
									Address:
								</Grid>
								<Grid
									item
									xs={10}
									className={classes.infoContent}
								>
									{supplierInfo.address || "Address"}
								</Grid>
							</Grid>
						</div>
						<PurchaseOrderAllocationTable items={allocation} type={0} branchidno={branchidno}/>
						<div className={classes.miniTitle}>
									Items
						</div>
						<PurchaseOrderApprovalTable items={items}/>
						<div className={classes.infoTotal}>
							<div className={classes.infoTotalContent}>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<LocalShippingTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Shipping: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(shipTotal).format('0,0.00')}	
									</div>							
								</div>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<ShoppingBasketTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Sub-Total: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(poTotal).format('0,0.00')}	
									</div>
								</div>
								<div style={{justifyContent: 'space-between'}} className={classes.infoTotalItem}>
									<div style={{display:'flex', alignItems:'center', paddingRight: '15px', justifyContent:'flex-start'}}>
									<ShoppingCartTwoToneIcon
										className={classes.infoTotalIcon}
									/>
									{"Total: "}
									</div>
									<div style={{display:'flex', alignItems:'center', justifyContent:'flex-end'}}>
										{numeral(shipTotal + poTotal).format('0,0.00')}	
									</div>
								</div>	
							</div>
						</div>
						<TextField
							label="Notes"
							multiline
							rows={4}
							variant="outlined"
							value={notes || ''}
							className={classes.textarea}
							InputProps={{
								readOnly: true,
							  }}
						/>
					</CardContent>
				</Card>
				{/* <div className={classes.buttonContainer}>
					<Button variant="contained">Back</Button> 
					<Button variant="contained" color="primary" onClick={approve_po}>
						Approve
					</Button>
				</div> */}
			</div>
		</div>
	);
};

export default PurchaseOrderDetailsReference;
